import React, { memo} from 'react';
import { EonUiDropdown, EonUiDropdownOption } from "@eon-ui/eon-ui-components-react";
import "./device.selection.component.scss";

interface Option {
    value: string;
    label: string;
}

interface DeviceSelectionProps {
    value: string;
    options: Option[];
    changeHandler: (value: string) => void;
    t: (key: string) => string;
}

const DeviceSelectionComponent: React.FC<DeviceSelectionProps> = ({
    value,
    options,
    changeHandler,
    t
}) => {
    return (
        <div className="device-selection">
            <div className="device-selection-header">
                <b>{t("chatBot.nexthinkIntegration.smartSolution.deviceSelectionHeading")}</b>
            </div>
            <div className='device-selection-body'>
                <span className="note">{t("chatBot.nexthinkIntegration.smartSolution.deviceSelectionLabel")}</span>
                <div className="device-options">
                    <EonUiDropdown
                        onValueChanged={(event) => {changeHandler(event.target.value)}}
                        value={value}
                        name="dropdown"
                        size="small"
                    >
                        {options.map((val, index) => (
                            <EonUiDropdownOption
                                key={`${index.toString()}`}
                                value={val.value}
                                label={val.label}
                            />
                        ))}
                    </EonUiDropdown>
                </div>
            </div>
        </div>
    );
};

export default memo(DeviceSelectionComponent);